<script>
  import addBundleToBasket from '../events/addBundleToBasket.js';

  /**
 *
 *
 *
 *
 *
 */

  /*                */
  let { variationId, recommendationIds, widgetAdditionalClickTracking, totalPrice } = $props();

  const addBundleToBasketClickListener = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addBundleToBasket(variationId, recommendationIds, widgetAdditionalClickTracking, totalPrice);
  };

  const addToCartMessage = (recoIds) => {
    if (recoIds.length === 2) {
      return 'Alle 3 in den Warenkorb';
    } else if (recoIds.length === 1) {
      return '2 Artikel in den Warenkorb';
    } else {
      return 'Auswahl in den Warenkorb';
    }
  };
</script>

<div class="reco_aos_bundle_add_to_basket_button oc-pt-0 oc-br-50">
  <!--svelte-ignore a11y_click_events_have_key_events a11y-no-static-element-interactions-->
  <oc-button-v1
    icon-type-left="basket"
    size="100"
    variant="secondary"
    type="submit"
    onclick={addBundleToBasketClickListener}>
    {addToCartMessage(recommendationIds)}
  </oc-button-v1>
</div>
